import { useRef } from 'react';

// components
import StepOne from '../step-one/StepOne.js';
import StepTwo from '../step-two/StepTwo.js';
import StepThree from '../step-three/StepThree.js';

// styles
import {
    LandingDescriptionWrapper,
    HowItWorksTrigger,
    SeparatorLine,
    FirstRow,
    SecondRow,
    ThirdRow
} from './LandingDescription.styles.js';

export default function LandingDescription() {
    const contentRef = useRef(null);

    const handleScrollToContent = () => {
        contentRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <LandingDescriptionWrapper>
            <FirstRow ref={contentRef} className="panel-bg">
                <HowItWorksTrigger onClick={handleScrollToContent}>
                    HOW IT WORKS<span style={{ opacity: 0.66, marginLeft: 8 }}>↓</span>
                </HowItWorksTrigger>
                <SeparatorLine />
                <StepOne />
                <SeparatorLine />
                <StepTwo />
                <SeparatorLine />
                <StepThree />
            </FirstRow>
            <SecondRow />
            <ThirdRow />
        </LandingDescriptionWrapper>
    );
}
